import * as React from "react";
import { Selection } from "core/models";
import { cx } from "utils/join-classnames";
import { EditorSelections, EditorThumbnail } from "ui/components";
import { useEditorContext } from "ui/context/EditorContext";
import styles from "./EditorTabs.module.scss";

interface Props {
    onEnableTrim(selection: Selection): void;
    requestScreenshot(): string | null;
    onPreview(): void;
}

const EditorTabs: React.FC<Props> = ({
    onEnableTrim,
    requestScreenshot,
    onPreview,
}) => {
    const [activeTab, setActiveTab] = React.useState<"selection" | "thumbnail">(
        "selection",
    );
    const editorContext = useEditorContext();

    return (
        <div className={styles.tabs}>
            <div className={styles.tabs__header}>
                <div
                    className={cx(
                        styles.tabs__header__item,
                        activeTab === "selection"
                            ? styles.tabs__header__item__active
                            : null,
                    )}
                    onClick={() => setActiveTab("selection")}
                    role="presentation"
                >
                    Selections{" "}
                    <span className={styles.tabs__header__item__count}>
                        {editorContext.selections.length}
                    </span>
                </div>
                <div
                    className={cx(
                        styles.tabs__header__item,
                        activeTab === "thumbnail"
                            ? styles.tabs__header__item__active
                            : null,
                    )}
                    onClick={() => setActiveTab("thumbnail")}
                    role="presentation"
                >
                    Thumbnail
                </div>
            </div>
            <div
                className={cx(
                    styles.tabs__content,
                    activeTab === "selection"
                        ? styles.tabs_content__selection
                        : null,
                )}
            >
                {activeTab === "selection" && (
                    <EditorSelections
                        onEnableTrim={onEnableTrim}
                        onPreview={onPreview}
                    />
                )}
                {activeTab === "thumbnail" && (
                    <EditorThumbnail requestScreenshot={requestScreenshot} />
                )}
            </div>
        </div>
    );
};

export default EditorTabs;
